<template>
  <img
    :alt="alt"
    :src="display ||' @/assets/defaultImage.png'"
    :class="className"
    :width="width"
    :height="height"
    :style="style"
    @error="handleError"
  />
</template>

<script>
import defaultImage from "@/assets/defaultImage.png";
export default {
  props: {
    alt: {
      type: String,
      default: "icon",
    },
    src: String,
    width: [String, Number],
    height: [String, Number],
    className: [String, Array],
    style: [String, Object, Array],
  },
  data() {
    return {
      display: this.src,
    };
  },
  watch: {
    src(val) {
      if (val) {
        this.display = val;
      }
    },
  },
  methods: {
    handleError() {
      this.display = defaultImage;
    },
  },
};
</script>

<style></style>
